import axios from 'axios';
import CONST from '../config/const'

export const api = axios.create({
  baseURL: CONST.HOST
})

export const watch = {
  getWatchData: () => api.get('/api/treasurer/watch/list'),
  getWatchSearchData: (keyword) => api.get(`/api/treasurer/watch/list/search?keyword=${keyword}`),
}

export const seller = {
  getSeller: () => api.get('/api/treasurer/seller/list'),
  getSellerItem: (sellerId) => api.get(`/api/treasurer/seller/item/list/${sellerId}`),
  // getItemSellerList: (itemId) => api.post(`api/treasurer/seller/item/seller/list`, {itemId}),
  getItemSellerList: (itemId) => api.get(`/v2/api/treasurer/item/${itemId}`),
  // registration
  sellerRegistration: (email, password, shopName, shopUrl, shopNumber, shopClerkName, shopPhoneNumber) => api.post(`api/treasurer/seller/registration`, {email, password, shopName, shopUrl, shopNumber, shopClerkName, shopPhoneNumber}),
  sellerLogin: (email, password) => api.post(`api/treasurer/seller/login`, {email, password}),
  sellerItemPriceHistory: (sellerId) => api.get(`/api/treasurer/seller/item/price/trend?sellerId=${sellerId}`),
  sellerItemViewCount: (sellerId) => api.post(`/api/treasurer/seller/item/view/count`, {sellerId}),
  sellerRequestedLoan: (sellerId) => api.post(`/v2/api/treasurer/item/seller/requested/loan`, {sellerId})
}

export const sellerLogin = (email, password) => async dispatch => {
  try {
    const result = api.post(`api/treasurer/seller/login`, {email, password});
    return result
  } catch(e ) {
    console.log(e)
  }
}
